import React from 'react'
import createComponent from '@services/react-mount-component'
import PolaroidSlider from './polaroid-slider';
import CanvasSlider from './canvas-slider';

export default createComponent('.image-slider,.polaroid-slider',
  ({childNodes=[],rootElement}) => {
    const itemsContainer = childNodes.find(child => child.getAttribute('data-role') === 'items');
    const headerContainer = childNodes.find(child => child.getAttribute('data-role') === 'header');

    const items = Array.from(itemsContainer.children).map(
      element => ({
        alt: element.dataset.alternative,
        src: element.dataset.image,
        link: element.dataset.link,
        title: element.dataset.title,
        description: element.innerHTML
      })
    );

    const props = {
      items,
      title:headerContainer ? headerContainer.innerHTML : '',
      rootElement
    }

    if(rootElement.classList.contains('polaroid-slider')){
      return <PolaroidSlider {...props} />;
    }

    return <CanvasSlider  {...props} />;
  }
);